import { ADMIN_GET_NDA_AGREEMENT, ADMIN_GET_NDA_AGREEMENT_FAILED, ADMIN_GET_NDA_AGREEMENT_SUCCESS } from "./constants";

const initialState = {
    Loading: false,
    successMsg: "",
    errors: "",
    agreementList: []
}

const AdminNdaAgreementReducer = (state = initialState, action) =>{
switch(action.type){
    case ADMIN_GET_NDA_AGREEMENT:
        return{
            ...state,
            Loading: true,
            errors:"",
            successMsg:""
        }
    case ADMIN_GET_NDA_AGREEMENT_SUCCESS:
        return{
            ...state,
            Loading: false,
            agreementList: action.payload
        }
    case ADMIN_GET_NDA_AGREEMENT_FAILED:
        return{
            ...state,
            Loading: false,
            errors: action.payload
        }
    default: return state
}
}
export default AdminNdaAgreementReducer;